import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })


export class FulfillmentService {


    backendUrl: string = environment.apiUrl;
    url_final: string;


    constructor(private http: HttpClient) {
    }

    getUploadURl(type){
      this.url_final = this.backendUrl + "/rmsfe/generar_upload_url?type="
      this.url_final = `${this.url_final}${type}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    getUploadURlXlsx(type){
      this.url_final = this.backendUrl + "/rmsfe/generar_upload_url_xlsx?type="
      this.url_final = `${this.url_final}${type}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    subirArchivo(url_metodo, file){
      this.url_final = `${url_metodo}`;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'binary/octet-stream',
           'Anonymous': ''
        }),
      };
      var fd = new FormData();
      // console.log("el file name es")
      // console.log(file.name)
      fd.append('file', file, file.name);

      // console.log("el file es")
      // console.log(file)
      return this.http.put<any>(this.url_final, fd, httpOptions)
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    subirArchivoXLS(url_metodo, file){
      this.url_final = `${url_metodo}`;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Anonymous': ''
        }),
      };
    
      // Envía el archivo directamente en el cuerpo de la petición PUT
      return this.http.put<any>(this.url_final, file, httpOptions)
        .pipe(map(response => {
          return response;
        }));
    }

    validarOrden(entries, datos_envio, file_name){
      this.url_final = this.backendUrl + "/rmsfe/validar_multicanal"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, datos_envio, file_name})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarEditarOrden(order_id){
      this.url_final = this.backendUrl + "/shopi_orders/consultar_editar_orden_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { order_id})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    enviarOrden(entries, datos_envio, file_name){
      this.url_final = this.backendUrl + "/rmsfe/enviar_multicanal"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, datos_envio, file_name})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarStatus(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/status_multicanal_api?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarOrden(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_orden?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    setOnboardingComplete(){
      this.url_final = this.backendUrl + "/rmsfe/onboarding_complete"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    getOnboardingComplete(){
      this.url_final = this.backendUrl + "/rmsfe/get_onboarding_complete"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, {})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    cancelarOrden(order_id){
      this.url_final = this.backendUrl + "/rmsfe/cancelar_orden"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {order_id})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    pausarOrden(order_id){
      this.url_final = this.backendUrl + "/rmsfe/pausar_orden"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {order_id})
      .pipe(map(response => {
        return response;
      }));
    }

    desCancelarOrden(order_id){
      this.url_final = this.backendUrl + "/rmsfe/quitar_cancelar_orden"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {order_id})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    actualizarOrden(order_id, datos_envio){
      this.url_final = this.backendUrl + "/shopi_orders/actualizar_orden_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { order_id, datos_envio})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    agregarProducto(order_id, cantidad, sku){
      this.url_final = this.backendUrl + "/shopi_orders/agregar_producto_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { order_id, cantidad, sku})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    setReaundarOrden(order_id){
      this.url_final = this.backendUrl + "/rmsfe/reaundar_orden"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {order_id})
      .pipe(map(response => {
        return response;
      }));
    }

//!
    generarPlantilla(){
      this.url_final = this.backendUrl + "/rmsfe/generar_layout_ordenes_masivas_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {  observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }
    consultarInformeGenerarPlantilla(){
      this.url_final = this.backendUrl + "/rmsfe/status_layout_ordenes_masivas_api"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }
    mandarEdicionMasiva(file_name){
      this.url_final = this.backendUrl + "/rmsfe/cargar_formato_edicion_masiva_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { file_name })
      .pipe(map(response => {
        return response;
      }));
    }
    consultarStatusGuardadoOrdenesMasivo(){
      this.url_final = this.backendUrl + "/rmsfe/validar_status_guardado_ordenes_masivos"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }
    validar_existencia_sku_orden(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/validar_existencias_layout_sku_orden_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { datos_envio})
      .pipe(map(response => {
        return response;
      }));
    }

    guardar_ordenes_masivas(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/guardar_ordenes_masivas"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { datos_envio })
      .pipe(map(response => {
        return response;
      }));
    }

    surtirBO(item_id, item_detal_id){
      this.url_final = this.backendUrl + "/rmsfe/surtir_backorder"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { item_id,item_detal_id })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarStatusBO(item_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_status_bo?item_id="
      this.url_final = `${this.url_final}${item_id}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarBO(item_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_backorder?item_id="
       this.url_final = `${this.url_final}${item_id}`;
       return this.http.get<any>(this.url_final, { observe: 'response' })
       .pipe(map(response => {
         // console.log("la api es");
         // console.log(response)
         return response;
       }));
     }

    consultarTodoBO(seller_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_backorder_todo?seller_id="
       this.url_final = `${this.url_final}${seller_id}`;
       return this.http.get<any>(this.url_final, { observe: 'response' })
       .pipe(map(response => {
         // console.log("la api es");
         // console.log(response)
         return response;
       }));
     }

     surtirTodoBO(seller_id){
      this.url_final = this.backendUrl + "/rmsfe/surtir_todo_back_orders"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { seller_id })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarStatusTodoBO(seller_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_status_todo_bo?seller_id="
      this.url_final = `${this.url_final}${seller_id}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    // Nuevos servicios para el historial de lotes
    obtenerHistorialOrdenesMasivas() {
      this.url_final = this.backendUrl + "/rmsfe/historial_ordenes_masivas"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final)
      .pipe(map(response => {
        return response;
      }));
    }

    obtenerErroresBatch(batch_id) {
      this.url_final = this.backendUrl + "/rmsfe/errores_batch_ordenes_masivas"
      this.url_final = `${this.url_final}?batch_id=${batch_id}`;
      return this.http.get<any>(this.url_final)
      .pipe(map(response => {
        return response;
      }));
    }

    descargarExcelBatch(batch_id) {
      this.url_final = this.backendUrl + "/rmsfe/descargar_excel_batch"
      this.url_final = `${this.url_final}?batch_id=${batch_id}`;
      return this.http.get<any>(this.url_final)
      .pipe(map(response => {
        return response;
      }));
    }

//!

}
